import {
  InteractionType,
  ProfileInteractionPayload,
  ProfileInteractionStatus,
} from '@loyalty/shared-common/profile-api-client';

/**
 * Authoring sample payloads for the detail template modal, keyed by {@link InteractionType}.
 * Shape matches {@link ProfileInteractionPayload} (header + `details[]`, newest first).
 *
 * STORE_RECEIPT: derived from `tools/hashting/publish_hashting_status_update.http`
 * (cashback_entry_status_update_with_data). Values are fictional samples, not production data.
 */
const STORE_RECEIPT_SAMPLE_PAYLOAD: ProfileInteractionPayload = {
  id: 'profile-interaction-sample-001',
  accountId: 'account-sample-001',
  programId: 'program-sample-001',
  profileId: 'profile-sample-001',
  interactionId: 'interaction-sample-001',
  externalId: 'cashback-entry-sample-001',
  label: 'Ticket receipt',
  status: ProfileInteractionStatus.Pending,
  eventTimestamp: '2026-07-20T12:45:34.000Z',
  createdAt: '2022-08-23T10:40:27.508Z',
  updatedAt: '2026-07-20T12:45:34.000Z',
  detailTemplate: '',
  details: [
    {
      id: 'detail-sample-001',
      status: ProfileInteractionStatus.Pending,
      eventTimestamp: '2026-07-20T12:45:34.000Z',
      eventId: 'sample-event-id-0001',
      createdAt: '2026-07-20T12:45:34.000Z',
      data: {
        items: [],
        store: 'Babydump',
        date: '2022-08-03',
        amount: 30,
        currency: 'EUR',
        cashback_entry: {
          id: 'cashback-entry-sample-001',
          code: 'SAMPLECODE123',
          registration_date: '2022-08-23T10:40:27.5081310Z',
          status: 'Pending',
          status_date: '2022-08-23T10:47:48.1477917Z',
          language_id: 'NL',
          detail: {
            payment_info: {
              amount: 30,
              is_paid: false,
            },
            form: {
              input: [
                {
                  internal_id: 'firstname',
                  external_id: 'firstname',
                  value: 'Jane',
                },
                {
                  internal_id: 'lastname',
                  external_id: 'lastname',
                  value: 'Demo',
                },
                {
                  internal_id: 'email',
                  external_id: 'email',
                  value: 'member@example.com',
                },
                {
                  internal_id: 'iban',
                  external_id: 'iban',
                  value: 'BE000000000000',
                },
                {
                  internal_id: 'list1',
                  external_id: 'list1',
                  value: 'Babydump',
                },
                {
                  internal_id: 'date1',
                  external_id: 'date1',
                  value: '2022-08-03',
                },
                {
                  internal_id: 'list2',
                  external_id: 'list2',
                  value: '2 = 30€',
                },
                {
                  internal_id: 'invoice',
                  external_id: 'invoice',
                  value: 'https://example.com/receipt-sample.jpeg',
                },
                {
                  internal_id: 'accept1',
                  external_id: 'accept1',
                  value: 'true',
                },
              ],
            },
            context: {
              tag: 'sample',
            },
          },
          updated_at: '2026-07-20T12:45:34.0000000',
        },
      },
    },
  ],
};

const STARTER_SAMPLE_PAYLOADS: Record<InteractionType, ProfileInteractionPayload> = {
  STORE_RECEIPT: STORE_RECEIPT_SAMPLE_PAYLOAD,
};

export function getStarterSamplePayload(type: InteractionType): ProfileInteractionPayload {
  return STARTER_SAMPLE_PAYLOADS[type];
}

export function getStarterSamplePayloadJson(type: InteractionType): string {
  return JSON.stringify(getStarterSamplePayload(type), null, 2);
}
